<template>
  <v-app-bar
  id="app-bar"
  absolute
  app
  flat
  height="75"
  :style="`${!drawer ? 'left:150px':'left:260px'}`"
  style="display: block; position: fixed; z-index: 100; background-color: rgba(238, 238, 238, 1)"
  >
  
  <v-btn
  class="mr-3"
  elevation="1"
  fab
  small
  @click="setDrawer(!drawer)"
  >
  <v-icon v-if="value">
    mdi-view-quilt
  </v-icon>

  <v-icon v-else>
    mdi-dots-vertical
  </v-icon>
</v-btn>

<v-toolbar-title
class="hidden-sm-and-down font-weight-light"
v-text="$route.name"
/>

<v-spacer />



<div class="mx-3" />

    <!-- <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/"
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn> -->

 <!--    <v-menu
    bottom
    right
    offset-y


    >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
      class="ml-2"
      min-width="0"
      text
      v-bind="attrs"
      v-on="on"
      >

      <a href="#">
        <img
        src="@/assets/images/users/img-01.jpg"
        alt="image description"
        />
      </a>


      {{userName}}
    </v-btn>
  </template>




  <v-btn  @click="logoutMethod()">Logout</v-btn>


  
</v-menu> -->
<div class="userlogin dropdown">
  <ul>
    <li
    class="menu-item-has-children menu-item-has-mega-menu"
    >
    <figure>
      <a href="#">
        <v-img
          v-if="getUserImage == null"
          src="@/assets/images/imag-27.jpg"
          alt="image description"
          height= '30px'
          width= '30px'
        />
        <v-img
          v-if="getUserImage != null"
          :src="`${getDataUrl}/${getUserImage}`"
          alt="image Desc"
          height= '30px'
          width= '30px'
        />
      </a>
    </figure>
    <span class="allbutton-btnthemedropdown2"
    >{{userName}}</span
    >
    <div class="mega-menu">
      <ul class="themetabnav" role="tablist">
        
          <a  @click="logoutMethod()" style="margin-right:20px;">Logout</a>

      
      </ul>
      <br>
    </div>
  </li>
</ul>
</div>
 <!--    <v-btn
      class="ml-2"
      min-width="0"
      text
      @click="logoutMethod()"
    >
      <v-icon >mdi-account</v-icon>logout
    </v-btn> -->
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  
  import { baseURL2 } from "@/store/api.js";
  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [
      'Mike John Responded to your email',
      'You have 5 new tasks',
      'You\'re now friends with Andrew',
      'Another Notification',
      'Another one',
      ],
      logOutSuccess:false,
    }),
    created() {
      let myToken = localStorage.getItem('dgmeToken');
      if(myToken && myToken != 'null'){
        this.getLoggedInStatus = true;
        this.userName = localStorage.getItem('userName');
      }
    },
    computed: {
      ...mapState(['drawer']),
      getUserImage(){
      let user = JSON.parse(window.localStorage.getItem("currentUser"));
     //  console.log(`${this.getPresentUser}/${user.profile_image}`);
      return user.profile_image;
    },
    getDataUrl(){
      return baseURL2;
    }
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      logoutMethod() {
       //  console.log("hi ");
      // this.setLimit();

      this.$store.dispatch("logOutUser").then((data) => {

       //  console.log("logOutUser",data);
        if (data) {
          this.logOutSuccess = true;
          // this.$store.commit("SET_LOGGED_IN", true);
        }
        if (this.logOutSuccess) {

          // localStorage.setItem("dgmeToken", "null");
          // localStorage.setItem("currentUser", {});
          this.getLoggedInStatus = false;
          this.$router.push("/");
        }
      });
    },
    logout(){
     //  console.log("dsdsds");
    }

  },
}
</script>
